module.exports = __webpack_public_path__ + "img/HealthCritical.3cbda6ee.svg";